module.exports = __webpack_public_path__ + "52d80a7d38b4f64b41b30b371509928a.fbx";